/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindOrganizationByIdQueryResponse,
  FindOrganizationByIdPathParams,
} from "../types/FindOrganizationById.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findOrganizationByIdQueryKey = (
  organizationId: FindOrganizationByIdPathParams["organizationId"] | undefined
) =>
  [
    {
      url: "/v1/admin/organizations/:organizationId",
      params: { organizationId: organizationId },
    },
  ] as const

export type FindOrganizationByIdQueryKey = ReturnType<
  typeof findOrganizationByIdQueryKey
>

/**
 * @summary Find organization by user
 * {@link /v1/admin/organizations/:organizationId}
 */
export async function findOrganizationById(
  organizationId: FindOrganizationByIdPathParams["organizationId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindOrganizationByIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/admin/organizations/${organizationId}`,
    ...requestConfig,
  })
  return res
}

export function findOrganizationByIdQueryOptions(
  organizationId: FindOrganizationByIdPathParams["organizationId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findOrganizationByIdQueryKey(organizationId)
  return queryOptions<
    ResponseConfig<FindOrganizationByIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindOrganizationByIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!organizationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findOrganizationById(organizationId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find organization by user
 * {@link /v1/admin/organizations/:organizationId}
 */
export function useFindOrganizationById<
  TData = ResponseConfig<FindOrganizationByIdQueryResponse>,
  TQueryData = ResponseConfig<FindOrganizationByIdQueryResponse>,
  TQueryKey extends QueryKey = FindOrganizationByIdQueryKey,
>(
  organizationId: FindOrganizationByIdPathParams["organizationId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindOrganizationByIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findOrganizationByIdQueryKey(organizationId)

  const query = useQuery(
    {
      ...findOrganizationByIdQueryOptions(organizationId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
